export enum CheckboxType {
    radio = 'radio',
    check = 'check',
}
